"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import "../styles/Relatorio.css"
import { FaFileExport, FaFileUpload, FaSpinner, FaExchangeAlt } from "react-icons/fa"

const API_URL = process.env.REACT_APP_API_URL || "https://api.ticketdovaqueiro.com"

const ExportacaoImportacaoAdmin = () => {
  const [eventos, setEventos] = useState([])
  const [eventoSelecionado, setEventoSelecionado] = useState("")

  const [categorias, setCategorias] = useState([])
  const [categoriaVaqueirama, setCategoriaVaqueirama] = useState("")
  const [arquivoVaqueirama, setArquivoVaqueirama] = useState(null)
  const [arquivoSuaSenha, setArquivoSuaSenha] = useState(null)

  const [loading, setLoading] = useState(false)
  const [importLoadingTipo, setImportLoadingTipo] = useState(null)
  const [corrigindoOrigem, setCorrigindoOrigem] = useState(false)
  const [inputKey, setInputKey] = useState(Date.now())

  useEffect(() => {
    const buscarEventos = async () => {
      try {
        setLoading(true)
        const response = await axios.get(`${API_URL}/events`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
        setEventos(response.data)
      } catch (err) {
        console.error("Erro ao buscar eventos:", err)
      } finally {
        setLoading(false)
      }
    }

    buscarEventos()
  }, [])

  useEffect(() => {
    const buscarCategorias = async () => {
      setCategoriaVaqueirama("")
      setCategorias([])

      if (!eventoSelecionado) return

      try {
        const response = await axios.get(`${API_URL}/events/${eventoSelecionado}/categorias`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
        setCategorias(response.data)
      } catch (err) {
        console.error("Erro ao buscar categorias:", err)
      }
    }

    buscarCategorias()
  }, [eventoSelecionado])

  const handleExportarEvento = async () => {
    if (!eventoSelecionado) {
      alert("Selecione um evento para exportar!")
      return
    }

    try {
      const response = await axios.get(`${API_URL}/events/${eventoSelecionado}/exportar`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        responseType: "blob",
      })

      const blob = new Blob([response.data], { type: "application/json" })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", `evento-${eventoSelecionado}.json`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      console.error("Erro ao exportar evento:", err)
      alert("Erro ao exportar dados do evento.")
    }
  }

  const montarResumoImportacao = (data) => {
    const resumo = data?.resumoPorCategoria
      ? Object.entries(data.resumoPorCategoria)
          .map(([categoria, quantidade]) => `${categoria}: ${quantidade}`)
          .join("\n")
      : ""

    return [
      `✅ ${data?.mensagem || "Importação concluída!"}`,
      `Importadas: ${data?.importados ?? 0}`,
      `Criadas: ${data?.criadas ?? 0}`,
      `Atualizadas: ${data?.atualizadas ?? 0}`,
      resumo ? `\nResumo por categoria:\n${resumo}` : "",
    ].filter(Boolean).join("\n")
  }

  const handleImportarPdfVaqueirama = async () => {
    if (!eventoSelecionado || !categoriaVaqueirama || !arquivoVaqueirama) {
      alert("Selecione o evento, a categoria e anexe o PDF do Senha da Vaqueirama!")
      return
    }

    const formData = new FormData()
    formData.append("file", arquivoVaqueirama)
    formData.append("tipoImportacao", "senhaVaqueirama")
    formData.append("categoria", categoriaVaqueirama)

    try {
      setImportLoadingTipo("senhaVaqueirama")

      const response = await axios.post(`${API_URL}/events/${eventoSelecionado}/importar-pdf`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      })

      alert(montarResumoImportacao(response.data))
      setArquivoVaqueirama(null)
      setInputKey(Date.now())
    } catch (err) {
      console.error("Erro ao importar PDF Senha da Vaqueirama:", err)
      alert(err.response?.data?.erro || "Erro ao importar o PDF do Senha da Vaqueirama.")
    } finally {
      setImportLoadingTipo(null)
    }
  }

  const handleImportarPdfSuaSenha = async () => {
    if (!eventoSelecionado || !arquivoSuaSenha) {
      alert("Selecione o evento e anexe o PDF do Sua Senha!")
      return
    }

    const formData = new FormData()
    formData.append("file", arquivoSuaSenha)
    formData.append("tipoImportacao", "suaSenha")

    try {
      setImportLoadingTipo("suaSenha")

      const response = await axios.post(`${API_URL}/events/${eventoSelecionado}/importar-pdf`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      })

      alert(montarResumoImportacao(response.data))
      setArquivoSuaSenha(null)
      setInputKey(Date.now())
    } catch (err) {
      console.error("Erro ao importar PDF Sua Senha:", err)
      alert(err.response?.data?.erro || "Erro ao importar o PDF do Sua Senha.")
    } finally {
      setImportLoadingTipo(null)
    }
  }


  const handleCorrigirOrigemImportados = async () => {
    if (!eventoSelecionado) {
      alert("Selecione um evento para corrigir os pedidos importados.")
      return
    }

    const confirmar = window.confirm(
      "Isso vai transformar os pedidos importados por PDF que estão como PRESENCIAL em ANTECIPADO neste evento. Deseja continuar?"
    )

    if (!confirmar) return

    try {
      setCorrigindoOrigem(true)

      const response = await axios.post(
        `${API_URL}/events/${eventoSelecionado}/importacoes-pdf/origem-antecipado`,
        {},
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )

      const data = response.data || {}
      alert(
        [
          data.mensagem || "Origem dos pedidos importados atualizada.",
          `Encontrados: ${data.totalEncontrados ?? 0}`,
          `Alterados: ${data.modificados ?? 0}`,
        ].join("\n")
      )
    } catch (err) {
      console.error("Erro ao corrigir origem dos importados:", err)
      alert(err.response?.data?.erro || "Erro ao corrigir origem dos pedidos importados.")
    } finally {
      setCorrigindoOrigem(false)
    }
  }

  const importandoVaqueirama = importLoadingTipo === "senhaVaqueirama"
  const importandoSuaSenha = importLoadingTipo === "suaSenha"
  const importando = Boolean(importLoadingTipo) || corrigindoOrigem

  return (
    <div className="relatorio-container">
      <h2 className="relatorio-titulo">📦 Exportar / Importar Senhas do Evento</h2>

      <div className="form-group">
        <label>Selecione o Evento</label>
        <select
          value={eventoSelecionado}
          onChange={(e) => setEventoSelecionado(e.target.value)}
          disabled={loading || importando}
        >
          <option value="">-- Selecione --</option>
          {eventos.map((evento) => (
            <option key={evento._id} value={evento._id}>
              {evento.nome}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: "flex", gap: "15px", marginTop: "20px", flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 300px", padding: "20px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
          <h3>⬇️ Exportar Dados</h3>
          <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
            Baixe o backup JSON completo de todos os pedidos e senhas do evento.
          </p>
          <button
            className="botao-relatorio"
            onClick={handleExportarEvento}
            disabled={!eventoSelecionado || loading || importando}
            style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}
          >
            <FaFileExport /> Exportar Evento Completo
          </button>
        </div>

        <div style={{ flex: "1 1 300px", padding: "20px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
          <h3>⬆️ Importar Senha da Vaqueirama</h3>
          <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
            Use esta opção quando o PDF vier separado por categoria. Você escolhe a categoria antes de importar.
          </p>

          <div className="form-group" style={{ marginBottom: "10px" }}>
            <label>Categoria</label>
            <select
              value={categoriaVaqueirama}
              onChange={(e) => setCategoriaVaqueirama(e.target.value)}
              disabled={!eventoSelecionado || categorias.length === 0 || importando}
            >
              <option value="">-- Selecione a Categoria --</option>
              {categorias.map((cat, index) => (
                <option key={index} value={cat.nome || cat}>
                  {cat.nome || cat}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group" style={{ marginBottom: "15px" }}>
            <label>PDF Senha da Vaqueirama</label>
            <input
              key={`vaqueirama-${inputKey}`}
              type="file"
              accept="application/pdf"
              disabled={!eventoSelecionado || importando}
              onChange={(e) => setArquivoVaqueirama(e.target.files?.[0] || null)}
            />
          </div>

          <button
            className="botao-relatorio"
            onClick={handleImportarPdfVaqueirama}
            disabled={importando || !eventoSelecionado}
            style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", backgroundColor: "#28a745" }}
          >
            {importandoVaqueirama ? <FaSpinner className="fa-spin" /> : <FaFileUpload />}
            {importandoVaqueirama ? "Processando..." : "Importar Vaqueirama"}
          </button>
        </div>

        <div style={{ flex: "1 1 300px", padding: "20px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
          <h3>⬆️ Importar Sua Senha</h3>
          <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
            Use esta opção quando o PDF vier com várias categorias misturadas. O sistema identifica Master, Jovem, Profissional e demais categorias cadastradas no evento.
          </p>

          <div className="form-group" style={{ marginBottom: "15px" }}>
            <label>PDF Sua Senha</label>
            <input
              key={`sua-senha-${inputKey}`}
              type="file"
              accept="application/pdf"
              disabled={!eventoSelecionado || importando}
              onChange={(e) => setArquivoSuaSenha(e.target.files?.[0] || null)}
            />
          </div>

          <button
            className="botao-relatorio"
            onClick={handleImportarPdfSuaSenha}
            disabled={importando || !eventoSelecionado}
            style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", backgroundColor: "#0069d9" }}
          >
            {importandoSuaSenha ? <FaSpinner className="fa-spin" /> : <FaFileUpload />}
            {importandoSuaSenha ? "Processando..." : "Importar Sua Senha"}
          </button>
        </div>

        <div style={{ flex: "1 1 300px", padding: "20px", border: "1px solid #f0c36d", borderRadius: "8px", backgroundColor: "#fff8e5" }}>
          <h3>🔁 Corrigir importados</h3>
          <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
            Use esta opção se PDFs importados anteriormente aparecerem como Presencial. Eles serão marcados como Antecipado.
          </p>

          <button
            className="botao-relatorio"
            onClick={handleCorrigirOrigemImportados}
            disabled={importando || !eventoSelecionado}
            style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", backgroundColor: "#f0ad4e" }}
          >
            {corrigindoOrigem ? <FaSpinner className="fa-spin" /> : <FaExchangeAlt />}
            {corrigindoOrigem ? "Corrigindo..." : "Corrigir para Antecipado"}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ExportacaoImportacaoAdmin
